const { debounce } = window.BAO.Utils

class GiftCardDetail extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.increment = this.dataset.increment
    this.minAmount = this.dataset.minAmount
    this.maxAmount = this.dataset.maxAmount

    this.typeError = this.els['type-error']?.element
    this.minError = this.els['min-error']?.element
    this.maxError = this.els['max-error']?.element
    this.incrementError = this.els['increment-error']?.element
    this.unavailableError = this.els['unavailable-error']?.element

    this.resetErrors = this.resetErrors.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.getVariant = this.getVariant.bind(this)
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.input.element,
      'input',
      debounce(e => {
        this.handleInput(e)
      }, 300),
    )
  }

  handleInput (e) {
    const value = e.target.value

    this.resetErrors()

    if (value === '') return

    if (isNaN(value) || value <= 0) {
      this.typeError.removeAttribute('aria-hidden')
    } else if (value < parseInt(this.minAmount)) {
      this.minError.removeAttribute('aria-hidden')
    } else if (value > parseInt(this.maxAmount)) {
      this.maxError.removeAttribute('aria-hidden')
    } else if (value % this.increment !== 0) {
      this.incrementError.removeAttribute('aria-hidden')
    } else {
      const variant = this.getVariant(value)

      if (variant === null) {
        this.unavailableError.removeAttribute('aria-hidden')

        return
      }

      this.els.drawerTrigger.element.disabled = false
      this.els['selected-variant'].element.dataset.value = value
      this.els['selected-variant'].element.value = variant
      this.externalEls['drawer-variant-title'].element.textContent = `${value}`

      const url = new URL(window.location)
      url.searchParams.set('variant', variant)
      window.history.replaceState({}, '', url)
    }
  }

  getVariant (value) {
    const variants = this.els.variant.elements

    if (!variants) return null

    for (const variant of variants) {
      if (variant.dataset.variantPrice === value) {
        return variant.dataset.variantId
      }
    }

    return null
  }

  resetErrors () {
    this.els.drawerTrigger.element.disabled = true
    this.typeError?.setAttribute('aria-hidden', 'true')
    this.minError?.setAttribute('aria-hidden', 'true')
    this.maxError?.setAttribute('aria-hidden', 'true')
    this.incrementError?.setAttribute('aria-hidden', 'true')
    this.unavailableError?.setAttribute('aria-hidden', 'true')
  }
}

if (!customElements.get('gift-card-detail')) {
  customElements.define('gift-card-detail', GiftCardDetail)
}
